import { Controller } from '@hotwired/stimulus';

export class DataLayerController extends Controller {
  static values = {
    event: String,
    payload: {
      default: {},
      type: Object,
    },
  };

  push() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: this.eventValue,
      ...this.payloadValue,
    });
  }
}
